import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const InputOptionCollection = React.forwardRef((props, ref) => (
    <div className={classNames('input-option', { 'form-errors': props.errors })}>
        <input
            type={props.type}
            name={props.name}
            id={props.id}
            value={props.value}
            defaultChecked={props.checked}
            ref={ref}
        />
        <label
            className={classNames({ 'form-errors': props.errors })}
            htmlFor={props.id}
            title={props.label.trim()}
        >
            {props.icon && <i className={`icon icon-${props.icon}`}></i>}
            <span>{props.label}</span>
        </label>
    </div>
));

InputOptionCollection.propTypes = {
    type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    checked: PropTypes.bool,
    icon: PropTypes.string,
    errors: PropTypes.object
};

export default InputOptionCollection;
